import React from 'react';

interface VideoPlayerProps {
    url: string;
    onEnded: () => void;
}

const VideoPlayer: React.FC<VideoPlayerProps> = ({ url, onEnded }) => {
    return (
        <div className="absolute inset-0 flex items-center justify-center">
            <video autoPlay controls className="w-full h-full object-contain bg-black" onEnded={onEnded}>
                <source src={url} type="video/mp4" />
                Tu navegador no soporta el tag de video.
            </video>
        </div>
    );
};

export default VideoPlayer;
